<button
    class="custom-button"
    [ngClass]="{
        'accent-btn': type === 'accent',
        'approve-btn': type === 'approve',
        'change-icon-theme': changeIconTheme,
        'clear-all-btn': type ===  'clear-all',
        'default-btn': type === 'default',
        'disabled-btn': disabled,
        'icon-btn': type === 'icon',
        'outlined-btn': type === 'outlined',
        'primary-btn': type === 'primary',
        'refresh-btn': type === 'refresh',
        'reject-btn': type === 'reject',
        'table-btn': type === 'table-btn',
    }"
    [disabled]="disabled"
    (click)="$event.preventDefault(); afterClick.emit()"
    [matTooltip]="tooltip ? (tooltip | translate) : (label | translate)"
    [style.--iconWidth]="isIcon ? iconWidth : '1rem'"
    [style.--iconHeight]="isIcon ? iconHeight : '1rem'"
>
    @if (isIcon && iconPosition === 'left') {
        <img [src]="iconPath" alt="icon" />
    }

    {{ label | translate }}

    @if (isIcon && iconPosition === 'right') {
        <img [src]="iconPath" alt="icon" />
    }

    @if (count) {
        <span>{{ count }}</span>
    }
</button>
